import Layout from "../components/Layout";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { Toast } from "primereact/toast";
import { setAuth } from "../redux/features/auth.feature";
import AssessmentInfoCard from "../components/AssessmentInfoCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import defaultUser from '../assets/images/user_default.png'
import QuarterNames from "../components/QuarterNames";

import "./profile.css";
const Profile = () => {
  const primeToast = useRef(null);
  const { user, token } = useSelector((state) => state["auth"]);
  const [supperVisorList, setSupperVisorList] = useState({
    isLoading: false,
    supperVisors: [],
  });
  const [selectedSupperVisor, setSelectedSupperVisor] = useState(
    user.supervisorID === null ? -1 : user.supervisorID
  );
  const [assessmentSummary, setAssessmentSummary] = useState([]);
  const [userAssessmentInfo, setUserAssessmentInfo] = useState([]);
  const [userCompetencyInfo, setUserCompetencyInfo] = useState([]);
  const [userMatrixInfo, setUserMatrixInfo] = useState([]);
  const [competencyAssessmentSummary, setCompetencyAssessmentSummary] = useState([]);
  const [quarterName, setQuarterName] = useState("");
  const [qurarterID,setQuarterID]=useState("");
  const [superviseeList,setSuperviseeList]=useState([]);

  let dispatch = useDispatch();

  useEffect(() => {
    console.log(user);
    SupervisorList();
    getAssessmentSummary();
    userAssessmentInformation(user.registerID,user.quarterID);
    getCompetencyAssessmentSummary(user.registerID,user.quarterID);
    userCompetencyInformation(user.registerID,user.quarterID);
    userMatrixSummaryInformation(user.registerID,user.quarterID);
    setQuarterName(user.quarterName);
    getSuperviseeList(user.registerID);
  }, []);


  const updateLocalUser = async () => {
    const payload = {
      user: {},
      token: token,
    };
    const userResponse = await axios.get(
      BASE_URL + "/api/Utility/UserProfile/" + user.registerID
    );
    if (userResponse.status === 200) {
      payload.user = userResponse.data[0];
      dispatch(setAuth(payload));
      window.location.reload();
    }
  };

  const childToParent = () => {
    var e = document.getElementById("ddlQuarter");
    var _selectedValue = e.value==="-1"?user.quarterID:e.value;
    setQuarterName(e.value==="-1"?user.quarterName:e.options[e.selectedIndex].text);
    userAssessmentInformation(user.registerID,_selectedValue);
    getCompetencyAssessmentSummary(user.registerID,_selectedValue);
    userCompetencyInformation(user.registerID,_selectedValue);
    userMatrixSummaryInformation(user.registerID,_selectedValue);
    setQuarterID(_selectedValue);
  }

  const onSupperVisorUpdateBtnClick = () => {
    if (selectedSupperVisor === -1) {
      primeToast.current.show({
        severity: "error",
        summary: "error",
        detail: "Please select valid supervisor",
        life: 3000,
      });
    } else {
      updateSupperVisor();
    }
  };

  async function updateSupperVisor() {
    const response = await axios.post(
      BASE_URL + "/api/supervisor/UpdateSupervisor",
      {
        registerID: user.registerID,
        supervisorID: selectedSupperVisor,
      }
    );
    if (response.status === 200) {
      updateLocalUser();
      primeToast.current.show({
        severity: "success",
        summary: "success",
        detail: "Supervisor Updated Successfully",
        life: 3000,
      });
    }
  }

  const getAssessmentSummary = async () => {
    try {
      const response = await axios.get(
        BASE_URL +
          "/api/assesmentinformation/GetAssesmentSummary/" +
          user.registerID
      );
      if (response.status === 200) {
        setAssessmentSummary(response.data);
      }
    } catch (e) {}
  };

  const SupervisorList = async () => {
    try {
      setSupperVisorList({ isLoading: true, supperVisors: [] });
      const response = await axios.get(
        BASE_URL + "/api/supervisor/SupervisorList/"+user.registerID
      );
      if (response.status === 200) {
        setSupperVisorList({ isLoading: false, supperVisors: response.data });
      } else {
        setSupperVisorList({ isLoading: false, supperVisors: [] });
      }
    } catch (e) {
      console.log(e);
      setSupperVisorList({ isLoading: false, supperVisors: [] });
    }
  };

  const userAssessmentInformation = (id,quarterID) => {
    const data = {registerId:id,quarterID:quarterID};
    axios
      .post(BASE_URL + "/api/utility/UserAssesmentInfromation/", JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          setUserAssessmentInfo(response.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getSuperviseeList = (id) => {
    const data = {registerId:id};
    axios
      .post(BASE_URL + "/api/utility/GetSuperviseeList/", JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          setSuperviseeList(response.data);
          console.log(response.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const userCompetencyInformation = (id,quarterID) => {
    const data = {registerId:id,quarterID: quarterID};
    axios
      .post(BASE_URL + "/api/utility/UserCompetencyInfromation/", JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          setUserCompetencyInfo(response.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const userMatrixSummaryInformation = (id,quarterID) => {
    const data = {registerId:id,quarterID:quarterID};
    axios
      .post(BASE_URL + "/api/utility/UserMatrixSupervisorMark/", JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          setUserMatrixInfo(response.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const downloadMyIDP = () => {
    var _qurarterID=qurarterID;
    if(_qurarterID===""|| _qurarterID===-"-1")
    {
      _qurarterID=user.quarterID;
    }
    window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + user.registerID+"&QuarterID=" + _qurarterID));
  };

  const getCompetencyAssessmentSummary = async (registerID,userRoleID) => {
    console.log(userRoleID);
    try {
      const response = await axios.post(
        BASE_URL + "/api/competencyinformation/CompetencyUserStatusCount",
        {
          RegisterID: registerID,
          UserRoleID: userRoleID,
        }
      );

      if (response.status === 200) {
        setCompetencyAssessmentSummary(response.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Layout>
      <Toast ref={primeToast} />
      <div className="row">
        <div id="divProfile" className="col-md-5">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                <b><i class="bi bi-person-lines-fill"></i> Profile</b>
                <span className="text-danger float-end"><i class="bi bi-bookmark-check"></i><b> {user.roleName}</b></span>
              </div>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-center">
                <img src={user.profileImage !== null ? "data:image/png;base64,"+user.profileImage : defaultUser} width={100}
                     height={100}
                     style={{borderRadius:"50%"}}
                     alt="user profile" className=" m-1" />
              </div>


              <div className="row g-3 mb-1 align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="employeeName" className="col-form-label">
                    <b>Emp Name:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="employeeName"
                    className="form-control"
                    disabled={true}
                    value={user.employeeName}
                  />
                </div>
              </div>

              <div className="row g-3 mb-1 align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="employeeCode" className="col-form-label">
                    <b>Emp Code:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="employeeCode"
                    className="form-control"
                    disabled={true}
                    value={user.employeeCode}
                  />
                </div>
              </div>
              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="department" className="col-form-label">
                    <b>Department:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="department"
                    className="form-control"
                    disabled={true}
                    value={user.department}
                  />
                </div>
              </div>

              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="section" className="col-form-label">
                    <b>Section:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="section"
                    className="form-control"
                    disabled={true}
                    value={user.section}
                  />
                </div>
              </div>
              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="designation" className="col-form-label">
                    <b>Designation:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="designation"
                    className="form-control"
                    disabled={true}
                    value={user.designation}
                  />
                </div>
              </div>
              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="dob" className="col-form-label">
                    <b>DOB:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="dob"
                    className="form-control"
                    disabled={true}
                    value={user.dob}
                  />
                </div>
              </div>
              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="doj" className="col-form-label">
                    <b>DOJ:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="doj"
                    className="form-control"
                    disabled={true}
                    value={user.doj}
                  />
                </div>
              </div>
              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="email" className="col-form-label">
                    <b>Email:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="email"
                    className="form-control"
                    disabled={true}
                    value={user.email}
                  />
                </div>
              </div>
              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="contactNo" className="col-form-label">
                    <b> Contact No:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="contactNo"
                    className="form-control"
                    disabled={true}
                    value={user.contactNo}
                  />
                </div>
              </div>
              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="quarterName" className="col-form-label">
                    <b>Quarter Name:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="quarterName"
                    className="form-control"
                    disabled={true}
                    value={user.quarterName}
                  />
                </div>
              </div>

              <div className="row g-3 mb-1  align-items-center">
                <div className="col-md-4 text-end">
                  <label htmlFor="supervisorName" className="col-form-label">
                    <b>Supervisor Name:</b>
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    id="supervisorName"
                    className="form-control"
                    disabled={true}
                    value={user.supervisorName}
                  />
                </div>
              </div>

{/* Supervisees List */}

<div>
<AssessmentInfoCard
            title={
              <span style={{ color: "#FFA500" }}>
                <b>Supervisee/s List({superviseeList.length})</b>
               
              </span>
              
            }
            >
               </AssessmentInfoCard>
</div>

<div style={{overflow:'scroll'}}>
            <table className="table">
            <thead>             
              <tr>
                <th scope="col" className="tdHeaderGroup">Employee Code</th>
                <th scope="col" className="tdHeaderGroup">Employee Name</th>
                <th scope="col" className="tdHeaderGroup">Designation</th>
                <th scope="col" className="tdHeaderGroup">Department</th>               
              </tr>
            </thead>
            <tbody>
              {superviseeList.map((value, index) => (
                <tr key={index}>
                  <td className="tdWhiteSpace">{value.employeeCode}</td>
                  <td className="tdWhiteSpace tdCenter">{value.employeeName}</td>
                  <td className="tdWhiteSpace">{value.designation}</td>
                  <td className="tdCenter">{value.department}</td>
                </tr>
              ))}           
            </tbody>
          </table>      
         
          </div>
            </div>
          </div>          
        </div>
        <div className="col-md-7">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                <div className="row">
                  <div className="col-8">
                  <h6 style={{fontSize: ".8rem",letterSpacing: ".8px",paddingTop:".4rem"}}> <b>Assessment Session:</b> {quarterName}/{new Date().getFullYear()}</h6>
                  </div>
                  <div className="col-4">
                    <button className="btn btn-primary btn-sm float-end" onClick={downloadMyIDP}>
                      <i class="bi bi-file-earmark-pdf"></i> My IDP
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-7">
                  <span className="fw-bold">Supervisor Name</span>
                  <select
                    className="form-select" /*disabled={user.isSupervisorEnable>0}*/
                    disabled={true}
                    onChange={(e) =>
                      setSelectedSupperVisor(e.currentTarget.value)
                    }
                    aria-label=".form-select-sm example"
                    value={selectedSupperVisor}
                  >
                    <option value={-1}>Select Supervisor</option>

                    {supperVisorList.supperVisors.map((value, index) => (
                      <option key={index} value={value.registerID}>
                        {" "}
                        {value.employeeName}/{value.designation}/
                        {value.department}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-5">
                  <span className="fw-bold">Assessment Session</span>
                  <QuarterNames childToParent={childToParent}/>
                  
                </div>

{/*                <div className="col-md-3">
                  <button  disabled={user.isSupervisorEnable>0}
                    className="btn btn-primary btn-block"
                    onClick={onSupperVisorUpdateBtnClick}
                  >
                    <i class="bi bi-check-lg"></i> Update
                  </button>
                </div>*/}
              </div>
            </div>
          </div>

          <AssessmentInfoCard
            title={
              <span style={{ color: "#FFA500" }}>
                <b>Core Values</b>
              </span>
            }
            smallTitle={
              assessmentSummary.length !== 0 ? (
                <>
                  <span className="spOutText">Completed</span>{" "}
                  <span className="d-inline p-2 bg-success text-white font-bold">
                    {" "}
                    {assessmentSummary[0].totalAssestmentSubmission}
                  </span>
                  <span className="spOutText"> out of </span>
                  <span className="d-inline p-2 bg-primary text-white">
                    {assessmentSummary[0].totalAssestment}
                  </span>{" "}
                </>
              ) : (
                ""
              )
            }
          >
            <table className="table">
              <thead>
                <tr>
                    <th scope="col" className="tdHeaderGroupStart" colSpan={2}>Values</th>
                    <th scope="col" className="tdHeaderGroup" colSpan={3}>Self</th>
                    <th scope="col" className="tdHeaderGroupEnd" colSpan={3}>Supervisor</th>
                </tr>
                <tr>
                  <th scope="col" className="tdHeaderGroup">Name</th>
                  <th scope="col" className="tdHeaderGroup">RCL</th>
                  <th scope="col">Opinion</th>
                  <th scope="col" className="tdHeaderGroup">Mark</th>
                  <th scope="col" className="tdHeaderGroup">Gap</th>
                  <th scope="col">Opinion</th>
                  <th scope="col" className="tdHeaderGroup">Mark</th>
                  <th scope="col" className="tdHeaderGroup">Gap</th>
                </tr>
              </thead>
              <tbody>
                {userAssessmentInfo.map((value, index) => (
                  <tr key={index}>
                    <td className="tdWhiteSpace">{value.assestmentName}</td>
                    <td className="tdWhiteSpace tdCenter">{value.rca}</td>
                    <td className="tdWhiteSpace">{value.selfOpinion}</td>
                    <td className="tdCenter">{value.selfAssesmentMark}</td>
                    <td className="tdCenter">{value.selfGap}</td>
                    <td className="tdWhiteSpace">{value.supervisorOpinion}</td>
                    <td className="tdCenter">{value.supervisorAssesmentMark}</td>
                    <td className="tdCenter">{value.supervisorGap}</td>
                  </tr>
                ))}
              <tr>
                <td colSpan={1} className="tdCenter"><b>Total</b></td>
                <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.rca)).reduce((prev, next) => prev + next)}</b></td>
                <td colSpan={1} className="tdCenter"></td>
                <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.selfAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.selfGap)).reduce((prev, next) => prev + next)}</b></td>
                <td/>
                <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.supervisorAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
              </tr>
              </tbody>
            </table>            
          </AssessmentInfoCard>

          <AssessmentInfoCard
            title={
              <span style={{ color: "#eb4034" }}>
                <b>Core Competency</b>
              </span>
            }
            smallTitle={
              competencyAssessmentSummary.length !== 0 ? (
                <>
                  <span className="spOutText">Completed</span>
                  <span className="d-inline p-2 bg-success text-white font-bold">
                    {competencyAssessmentSummary[0].totalComplete}
                  </span>
                  <span className="spOutText"> out of </span>
                  <span className="d-inline p-2 bg-primary text-white font-bold">
                    {competencyAssessmentSummary[0].totalCount}
                  </span>{" "}
                </>
              ) : (
                ""
              )
            }
          >
            <table className="table">
              <thead>
                <tr>
                    <th scope="col" className="tdHeaderGroupStart" colSpan={2}>Competency</th>
                    <th scope="col" className="tdHeaderGroup" colSpan={3}>Self</th>
                    <th scope="col" className="tdHeaderGroupEnd" colSpan={3}>Supervisor</th>
                </tr>                  
                <tr>
                  <th scope="col" className="tdHeaderGroup">Name</th>
                  <th scope="col" className="tdHeaderGroup">RCL</th>
                  <th scope="col">Opinion</th>
                  <th scope="col" className="tdHeaderGroup">Mark</th>
                  <th scope="col" className="tdHeaderGroup">Gap</th>
                  <th scope="col">Opinion</th>
                  <th scope="col" className="tdHeaderGroup">Mark</th>
                  <th scope="col" className="tdHeaderGroup">Gap</th>
                </tr>
              </thead>
              <tbody>
                {userCompetencyInfo.map((value, index) => (
                  <tr key={index}>
                    <td className="tdWhiteSpace">{value.competencyName}</td>
                    <td className="tdWhiteSpace tdCenter">{value.rca}</td>
                    <td className="tdWhiteSpace">{value.selfOpinion}</td>
                    <td className="tdCenter">{value.selfAssesmentMark}</td>
                    <td className="tdCenter">{value.selfGap}</td>
                    <td className="tdWhiteSpace">{value.supervisorOpinion}</td>
                    <td className="tdCenter">{value.supervisorAssesmentMark}</td>
                    <td className="tdCenter">{value.supervisorGap}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={1} className="tdCenter"><b>Total</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.rca)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1} className="tdCenter"></td>
                  <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.selfAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.selfGap)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1}/>
                  <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.supervisorAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
                </tr>
              </tbody>
            </table>
            
          </AssessmentInfoCard>
          <AssessmentInfoCard
            title={
              <span style={{ color: "#eb4034" }}>
                <b>Skill Will Matrix</b>
              </span>
            }
            smallTitle={
              userMatrixInfo.length !== 0 ? (
                <>
                 
                </>
              ) : (
                ""
              )
            }
          >
            <table className="table">
              <thead>                
                <tr>
                  <th scope="col" className="tdHeaderGroup">Matrix Title</th>
                  <th scope="col" className="tdHeaderGroup">Opinion</th>
                  <th scope="col" className="tdHeaderGroup">Will</th>
                  <th scope="col" className="tdHeaderGroup">RCL</th>
                  <th scope="col" className="tdHeaderGroup">Mark</th>
                  <th scope="col" className="tdHeaderGroup">Gap</th>
                </tr>
              </thead>
              <tbody>
                {userMatrixInfo.map((value, index) => (
                  <tr key={index}>
                    <td className="" style={{width:"300px"}}>{value.matrixTitle}</td>
                    <td className="tdWhiteSpace">{value.title}</td>                    
                    <td className="tdWhiteSpace tdCenter">{value.willValue}</td>
                    <td className="tdWhiteSpace tdCenter">{value.rca}</td>
                    <td className="tdWhiteSpace tdCenter">{value.totalMark}</td>
                    <td className="tdWhiteSpace tdCenter">{value.supervisorGap}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={3} className="tdCenter"><b>Total</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userMatrixInfo.length === 0 ? "": userMatrixInfo.map(item => Number(item.rca)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userMatrixInfo.length === 0 ? "": userMatrixInfo.map(item => Number(item.totalMark)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userMatrixInfo.length === 0 ? "": userMatrixInfo.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
                </tr>
              </tbody>
            </table>            
          </AssessmentInfoCard>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
